<section class="flex-column full-height bms-theme-content">
  @if (canShowHeader) {
    <vdw-dialog-header
      [title]="navigationHelper.getHeaderText(pageType, PATTERN_TRANSLATION_KEY) + createdObject"
      [isLocked]="isLocked"
      [lockIconConfig]="lockIconConfig"
      (backEvent)="navigationHelper.navigateBack()"
    />
  }
  <vdw-editor-header
    [identifier]="HEADER_IDENTIFIER"
    [menuItems]="[generalTab]"
    [selectedMenuItem]="generalTab"
    [isCreateNewPage]="!isEditingPattern()"
    [inProgress]="saving"
    [disableSaveButton]="isLocked"
    [disableDeleteButton]="isLocked"
    [extraPadding]="!canShowHeader"
    [canShowSave]="!navigationHelper.contentSwitcherDialogActive()"
    [canShowSettings]="false"
    (saveEvent)="savePattern(SAVE_TYPE.SAVE)"
    (saveAndCloseEvent)="savePattern(SAVE_TYPE.SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="savePattern(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (duplicateEvent)="duplicatePattern()"
    (deleteEvent)="deletePattern()"
    (cancelEvent)="navigateBack()"
  ></vdw-editor-header>
  <div class="bms-theme flex-column p-48 gap-8 overflow-hidden">
    <form [formGroup]="addPatternForm" class="flex-row gap-16 flex-start-center" appBreadcrumbFormLinker>
      <div class="flex-row gap-8">
        <p class="b1 required">{{ 'GENERAL.NAME' | bmsTranslate }}</p>
        <vdw-string-input formControlName="name" class="full-width" [placeholder]="'GENERAL.NAME_PLACEHOLDER' | bmsTranslate: {object: PATTERN_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase}">
          <ng-container error>
            <vdw-invalid-form-message *vdwCanShowErrorForFormControl="'name'; error: 'required'" [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
            <vdw-invalid-form-message
              *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'"
              [message]="'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate"
              [link]="getLoadLink()"
              [loadEntry]="getLoadEntry()"
              [compact]="true"
            ></vdw-invalid-form-message>
          </ng-container>
        </vdw-string-input>
      </div>
      <div class="flex-row gap-8">
        <p class="b1">{{ 'MACHINE.SETTINGS.DAYS' | bmsTranslate: {count: 2} }}</p>
        <mat-form-field class="full-width">
          <input matInput type="number" vdwL10nDecimal formControlName="numDays" (blur)="onNumDaysBlurred()" />
          @if (addPatternForm.value.numDays && !addPatternForm.controls.numDays.disabled) {
            <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addPatternForm.controls.numDays.reset()">
              <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="flex-row gap-8">
        <p class="b1">{{ 'GENERAL.DATETIME.START_TIME' | bmsTranslate }}</p>
        <vdw-time-picker-form-input controlName="startTime" [defaultTime]="DEFAULT_START_TIME" [notation]="24" [form]="addPatternForm" (inputBlur)="onStartTimeBlurred()"></vdw-time-picker-form-input>
      </div>
    </form>
    <vdw-crud-overview-data-page class="bms-theme-content no-padding" [config]="config" [canShowActions]="false"></vdw-crud-overview-data-page>
  </div>
</section>
